import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { Spinner } from './Spinner';
import { SpinnerItemSetWidget } from './SpinnerItemSetWidget';

export const spinnerPropertyLayout = LockablePropertyStripLayout<Spinner>((d, s, o, w, a) => [
    //
    // Configure Items
    w.createPopout({
        facade: a,
        image: 'deqo://icons/d2/spinner-items',
        text: 'Configure Items',
        ui: SpinnerItemSetWidget,
        onSelect() { }
    }),
    ...lockAndMoreLayout(d, s, o, w, a),
]);
